var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 812.98,
    height: 490.439,
    viewBox: "0 0 812.98 490.439",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(-407 -291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(375 238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1465-131",
    "data-name": "Path 1465",
    d: "M675.147,628.1a11.49,11.49,0,1,0,11.49,11.49h0a11.49,11.49,0,0,0-11.49-11.49Zm0,18.561a7.071,7.071,0,1,1,7.071-7.071h0a7.071,7.071,0,0,1-7.071,7.071Z",
    transform: "translate(-113.269 -156.487)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467-132",
    "data-name": "Path 1467",
    d: "M630.954,619.261h44.193V663a5.757,5.757,0,0,1-5.757,5.757H636.711A5.757,5.757,0,0,1,630.954,663V619.261Z",
    transform: "translate(-113.269 -156.487)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_944-133",
    "data-name": "Path 944",
    d: "M696.682,669.758H114.056a1.029,1.029,0,0,1,0-2H696.682a1.029,1.029,0,0,1,0,2Z",
    transform: "translate(293.73 81.512)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(1.18 53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5340-134",
    "data-name": "Path 5340",
    d: "M914.753,353.252H730.1a3.7,3.7,0,0,1-3.695-3.695v-34.8h1.478v34.8a2.219,2.219,0,0,0,2.217,2.217H914.753a2.219,2.219,0,0,0,2.217-2.217V314.51h1.478v35.047A3.7,3.7,0,0,1,914.753,353.252Z",
    transform: "translate(226.139 40.257)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 433.914,
    height: 1.478,
    transform: "translate(773.917 354.272)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(761.237 342.185)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(890.405 342.185)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(978.067 379.545)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(1044.708 379.545)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_270",
    "data-name": "Ellipse 270",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(1012.415 342.185)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_271",
    "data-name": "Ellipse 271",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(1193.378 342.185)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_272",
    "data-name": "Ellipse 272",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(1131.137 342.185)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 23.577,
    height: 16.249,
    transform: "translate(978.705 238)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 23.577,
    height: 16.249,
    transform: "translate(762.253 238)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 23.577,
    height: 16.249,
    transform: "translate(842.111 238)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5341-135",
    "data-name": "Path 5341",
    d: "M537.79,301.386a.739.739,0,0,1-.739-.739V264.172a3.7,3.7,0,0,1,3.695-3.695h35.967a.739.739,0,1,1,0,1.478H540.746a2.219,2.219,0,0,0-2.217,2.217v36.475a.739.739,0,0,1-.739.739Z",
    transform: "translate(275.574 54.363)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(841.267 302.593)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5342-136",
    "data-name": "Path 5342",
    d: "M922.529,300.647h-1.478V264.172a3.7,3.7,0,0,1,3.695-3.695h35.967v1.478H924.746a2.219,2.219,0,0,0-2.217,2.217Z",
    transform: "translate(175.323 54.363)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265-2",
    "data-name": "Ellipse 265",
    cx: 12.711,
    cy: 12.711,
    r: 12.711,
    transform: "translate(1125.016 302.593)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(15618.886 -22117.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5311-137",
    "data-name": "Path 5311",
    d: "M205.542,749.762c-1.842-4.191-3.589-9.011-1.746-13.2A11.22,11.22,0,0,1,209.6,731.1a27.942,27.942,0,0,1,7.858-1.938,109.67,109.67,0,0,1,25.548-.349c.62,4.907-.69,9.884-1.816,14.625-1.022,4.366-1.607,5.012-6.112,5.239C232.164,748.836,206.232,751.307,205.542,749.762Z",
    transform: "translate(-15288.737 22111.072)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5316-138",
    "data-name": "Path 5316",
    d: "M388.81,643.256c2.908-1.109,6.112-.707,9.229-.288,10.032,1.371,20.213,2.777,29.512,6.784,4.366,1.869,8.522,4.366,11.473,8.042,2.619,3.309,4.147,7.361,5.6,11.351l3.353,9.185A44.22,44.22,0,0,1,450.9,689.1c1.048,10.993-6.47,21.357-15.926,27.067s-20.589,7.745-31.433,9.875-21.732,4.488-32.533,6.985a130.974,130.974,0,0,1-15.306,3.012c-11.56,1.31-23.645-.62-34.629,3.2-4.366,1.528-8.653,3.8-13.184,4.855a82.02,82.02,0,0,1-9.116,1.388l-20.789,2.375a113.421,113.421,0,0,1-12.748.978c-9.081,0-18.013-2.148-26.831-4.3a6.785,6.785,0,0,1-2.619-1.057c-1.4-1.1-1.7-3.047-1.9-4.811q-1.336-11.709-2.34-23.444c-.21-2.541-.367-5.291,1.022-7.43,1.746-2.619,5.152-3.44,8.26-3.947a215.561,215.561,0,0,1,39.885-2.768c5.073-5.073,13.438-5.1,20.082-7.858a59.727,59.727,0,0,0,7.081-3.851,92.552,92.552,0,0,1,38.881-12.285,36.192,36.192,0,0,0,7.954-1.135c5.143-1.6,9.831-5.946,15.114-4.881.655-1.807,1.109-4.226,2.619-5.466.751-.637,1.676-1.065,2.366-1.746,1.458-1.476,1.589-3.8,1.371-5.859s-.707-4.174-.175-6.182a8.546,8.546,0,0,1,.969-2.157C379.589,645.142,383.544,642.819,388.81,643.256Z",
    transform: "translate(-15292.339 22121.945)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5317-139",
    "data-name": "Path 5317",
    d: "M388.81,643.256c2.908-1.109,6.112-.707,9.229-.288,10.032,1.371,20.213,2.777,29.512,6.784,4.366,1.869,8.522,4.366,11.473,8.042,2.619,3.309,4.147,7.361,5.6,11.351l3.353,9.185A44.22,44.22,0,0,1,450.9,689.1c1.048,10.993-6.47,21.357-15.926,27.067s-20.589,7.745-31.433,9.875-21.732,4.488-32.533,6.985a130.974,130.974,0,0,1-15.306,3.012c-11.56,1.31-23.645-.62-34.629,3.2-4.366,1.528-8.653,3.8-13.184,4.855a82.02,82.02,0,0,1-9.116,1.388l-20.789,2.375a113.421,113.421,0,0,1-12.748.978c-9.081,0-18.013-2.148-26.831-4.3a6.785,6.785,0,0,1-2.619-1.057c-1.4-1.1-1.7-3.047-1.9-4.811q-1.336-11.709-2.34-23.444c-.21-2.541-.367-5.291,1.022-7.43,1.746-2.619,5.152-3.44,8.26-3.947a215.561,215.561,0,0,1,39.885-2.768c5.073-5.073,13.438-5.1,20.082-7.858a59.727,59.727,0,0,0,7.081-3.851,92.552,92.552,0,0,1,38.881-12.285,36.192,36.192,0,0,0,7.954-1.135c5.143-1.6,9.831-5.946,15.114-4.881.655-1.807,1.109-4.226,2.619-5.466.751-.637,1.676-1.065,2.366-1.746,1.458-1.476,1.589-3.8,1.371-5.859s-.707-4.174-.175-6.182a8.546,8.546,0,0,1,.969-2.157C379.589,645.142,383.544,642.819,388.81,643.256Z",
    transform: "translate(-15292.339 22121.945)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5318-140",
    "data-name": "Path 5318",
    d: "M201.731,752.6c-5.4,6.26-10.163,8.5-18.624,8.295q-7.806-.183-15.594-.812a87.5,87.5,0,0,0-10.687-.5c-10.775.419-21.174,5.352-31.922,4.488a22.629,22.629,0,0,1-4.689-.873,13.647,13.647,0,0,1-6.365-3.859,17.391,17.391,0,0,1-3.615-8.478c-2.873-15.664,5-32.725,18.79-40.7A13.778,13.778,0,0,1,135,708.04a14.153,14.153,0,0,1,6.042,1.327l.131.052a45.692,45.692,0,0,1,14.966,9.989,8.436,8.436,0,0,0,2.288,1.842,7.86,7.86,0,0,0,2.7.506l11.473.725a27.185,27.185,0,0,1,5.763.795,45.809,45.809,0,0,1,6.06,2.619c6.173,2.759,13.018,3.493,19.689,4.558a2.942,2.942,0,0,1,1.746.7,2.733,2.733,0,0,1,.541,1.135,22.274,22.274,0,0,1-4.663,20.309Z",
    transform: "translate(-15276.893 22113.635)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5320-141",
    "data-name": "Path 5320",
    d: "M396.345,734.271c6.418-.175,13.621-.5,18.336,3.824,4.5,4.086,5.09,10.827,5.387,16.9l.341,7.046a14.075,14.075,0,0,1-.672,6.356c-1.537,3.493-5.754,5.178-9.6,4.977s-7.387-1.886-10.905-3.405a153.412,153.412,0,0,0-29.687-9.351q.5-7.308,1.659-14.546c.533-3.344.62-8.941,2.855-11.717,2.366-2.934,5.448-1.345,8.662-.8a69.531,69.531,0,0,0,13.63.725Z",
    transform: "translate(-15309.863 22110.516)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5322-142",
    "data-name": "Path 5322",
    d: "M514.316,776.835c-2.934,5.44-8.627,8.827-14.739,10.224a29.253,29.253,0,0,1-4.663.664c-7.727.48-15.359-1.659-22.806-3.772L462,781.1a31.919,31.919,0,0,0-5.326-1.187,36.546,36.546,0,0,0-7.369.253,130.615,130.615,0,0,1-35.8-1.607,6.312,6.312,0,0,1-2.768-.987,13.752,13.752,0,0,1-1.93-2.366c-2.75-3.309-5.71-5.239-2.454-9.6,1.877-2.532,5.361-3.8,6.819-6.706s.524-7.037-.341-10.041c-1.179-4.147-5.055-5.937-6.444-9.744-1.039-2.873.707-6.208,3.335-7.771s5.876-1.685,8.906-1.284,6,1.257,9.046,1.493c8.958.716,18.118-3.9,26.718-1.3,1.895.576,3.685,1.493,5.606,2a18.642,18.642,0,0,0,11.2-.969c1.257-.471,2.488-1.039,3.711-1.6a29.884,29.884,0,0,1,7.465-2.7c8.391-1.441,16.171,4.366,22.5,10.032a31.814,31.814,0,0,1,5.719,6.2,31.122,31.122,0,0,1,3.493,9.02C516.4,760.315,518.315,769.413,514.316,776.835Z",
    transform: "translate(-15314.353 22111.26)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_895",
    "data-name": "Ellipse 895",
    cx: 124.859,
    cy: 34.925,
    rx: 124.859,
    ry: 34.925,
    transform: "translate(-15130.301 22762.711)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_896",
    "data-name": "Ellipse 896",
    cx: 124.859,
    cy: 34.925,
    rx: 124.859,
    ry: 34.925,
    transform: "translate(-15130.301 22762.711)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5312-143",
    "data-name": "Path 5312",
    d: "M308.277,459.017a38.846,38.846,0,0,1-20.03,18.2,50.275,50.275,0,0,1-15.9,3.021c-5.929.271-11.979-.113-17.55-2.139-7.474-2.707-13.682-8.242-18.336-14.695s-7.858-13.822-10.644-21.252c-1.467-3.868-2.864-7.989-2.174-12.075,4.5-1.022,9.421-2.523,11.744-6.514,1.982-3.423,1.432-7.526.288-11.438-.323-1.109-.7-2.209-1.074-3.266-.873-2.532-3.885-7.343-1.746-9.508,1.336-1.371,6.933-2.069,8.862-2.96,5.946-2.742,11.429-6.706,17.96-8.007,5.649-1.126,11.482-.07,17.122,1.1a5.632,5.632,0,0,1,2.113.76,5.082,5.082,0,0,1,1.572,2.357c1.607,3.912,2.55,8.234,3.842,12.311,1.345,4.27,3.073,8.277,6.313,11.307,2.523,2.366,5.737,3.851,8.88,5.291l7.736,3.545a10.172,10.172,0,0,1,3.658,2.366,9.264,9.264,0,0,1,1.746,4.75,44.373,44.373,0,0,1-4.383,26.849Z",
    transform: "translate(-15291.332 22154.248)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_897",
    "data-name": "Ellipse 897",
    cx: 40.164,
    cy: 40.164,
    r: 40.164,
    transform: "translate(-15076.166 22489.42)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5314-144",
    "data-name": "Path 5314",
    d: "M370.1,510.526l-3.3-19.995c-1.668-10.032-3.388-20.257-8.05-29.294-3.065-5.92-21.226-16.607-22.7-18.144-3.807-3.947-23.3-11.124-27.4-13.691s-9.212-4.366-13.752-2.724c-.733,7.815-1.511,15.8-4.828,22.92a34.3,34.3,0,0,1-51.742,12.888c-7.78-5.859-12.765-14.9-15.088-24.352-.568-2.305-1.214-4.951-3.335-6.007-2.3-1.153-5.055.244-6.985,1.938-3.493,3.135-44.076,23.5-45.857,26s-2.619,5.606-3.493,8.609c9.543,21.252,18.275,42.531,27.818,63.783a5.439,5.439,0,0,1,.69,2.619,6.383,6.383,0,0,1-1.187,2.619c-4.68,7.518-4.532,16.974-4.016,25.81s1.144,18.17-2.8,26.089c-1.074,2.174-2.471,4.165-3.493,6.339-2.392,4.925-3.257,20.676-1.86,25.967h197.4c-3.763-10.347-2.331-31.11-1.545-42.094.55-7.684-.873-15.359-1.484-23.042C371.752,541.077,372.7,526.19,370.1,510.526Z",
    transform: "translate(-15283.733 22149.41)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5315-145",
    "data-name": "Path 5315",
    d: "M146.208,547.274a30.908,30.908,0,0,0-.1,7.622l2.506,36.034c.236,3.4.471,6.784.786,10.172.6,6.575,1.5,13.1,2.619,19.611a3.493,3.493,0,0,0,3.58,3.4c11.045,2.34,22.457,2.244,33.729,1.607,17.2-.96,34.375-3.152,51.6-2.777,4.436.1,9.6,0,12.294-3.492s1.126-9.142-2.384-11.962-8.277-3.492-12.783-3.492c-5.964-.061-11.927.786-17.873.437a88.536,88.536,0,0,1-16.083-2.96l-14.843-3.693c.568-4.5,2.279-8.731,3.9-13,2.916-7.57,5.64-15.393,5.693-23.5s-3-16.642-9.648-21.287c-5.466-3.816-12.5-4.523-19.165-4.366-4.846.14-13.219-1.022-17.646.873C148.888,538.027,146.863,543.842,146.208,547.274Z",
    transform: "translate(-15281.494 22135.537)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5321-146",
    "data-name": "Path 5321",
    d: "M195.614,650.617c0,.873-1.371,0-1.493-.934-.96-7.064-6.566-12.888-13.1-15.717s-13.97-2.977-21.043-2.305c-10.7,1.013-22.7,5.108-26.613,15.105-.926,2.34-1.345,4.872-2.48,7.116-1.257,2.462-3.309,4.427-4.671,6.819-2.349,4.139-2.445,9.212-1.6,13.892,2.279,12.486,10.818,23.164,21.165,30.56s22.44,11.814,34.5,15.8A598.26,598.26,0,0,0,278.073,744.3c5.378.812,10.809,1.563,15.961,3.292,4.61,1.545,8.923,3.859,13.429,5.675,10.478,4.208,21.75,5.71,32.917,7.186,1.9.244,4.086.419,5.492-.873,1.816-1.685,1.214-4.619.7-7.037a37.85,37.85,0,0,1,4.462-26.858c1.869-3.143,4.3-6.365,3.947-10.006-.419-4.243-4.645-7.247-8.854-7.928s-8.487.323-12.713.873a6.81,6.81,0,0,1-4.322-.428,8.635,8.635,0,0,1-1.694-1.5,19.148,19.148,0,0,0-22.3-3.117c-1.563.873-3.929-1.074-5.553-1.807l-18.362-8.312c-21.1-9.543-42.295-19.13-64.612-25.172a13.571,13.571,0,0,1-4.977-2.069c-1.109-.873-1.9-2.061-2.925-3.03-2.227-2.1-5.326-2.943-8-4.436S195,653.612,195.614,650.617Z",
    transform: "translate(-15278.73 22123.367)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5324-147",
    "data-name": "Path 5324",
    d: "M160.5,474.8a9.038,9.038,0,0,0-1.938,3.1,146.565,146.565,0,0,0-12.311,50.31,5.029,5.029,0,0,1-.568,2.436,10.656,10.656,0,0,1-1.283,1.388,4.82,4.82,0,0,0,.821,6.985c1.441-2.715,4.89-3.6,7.954-3.833,14.677-1.161,29.014,5.667,43.735,5.151-1.039-3.589-2.532-7.037-3.379-10.67-3.746-16.127,5.6-33.686-.131-49.219-1.144-3.108-3.056-6.164-6.068-7.526a16.16,16.16,0,0,0-3.885-1.03c-3.72-.672-11.124-3.545-14.721-2.392-1.327.428-1.851,1.676-2.951,2.427C164.1,473,161.884,473.395,160.5,474.8Z",
    transform: "translate(-15281.157 22143.932)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1040",
    "data-name": "Rectangle 1040",
    width: 194.71,
    height: 123.985,
    rx: 7.97,
    transform: "translate(-15094.668 22650.514)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_898",
    "data-name": "Ellipse 898",
    cx: 5.239,
    cy: 5.239,
    r: 5.239,
    transform: "translate(-15002.989 22707.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5343-148",
    "data-name": "Path 5343",
    d: "M390.281,211.316c4.047-7.636,9.19-22.855,17.359-25.677a64.946,64.946,0,0,1,13.981-2.978L435.506,188l-7.557-5.877q2.207-.131,4.411-.215l9.368,3.6-4.793-3.728c8.734-.09,17.749.819,24.517,6.135,5.77,4.533,11.486,21.7,12.41,28.982a55.438,55.438,0,0,1-1.019,20.883l-2.373,2.256a29.11,29.11,0,0,1-1.861-5.925,28.06,28.06,0,0,0-13.432-18.222l-.129-.073c-3.979-2.24-8.808-2.136-13.371-1.972l-21.672.78c-5.214.188-10.829.518-14.894,3.788-2.746,2.209-4.391,5.469-5.955,8.627-2.02,4.077-5.967,19.454-5.967,19.454s-2.233-2.9-3.3-.742a74.705,74.705,0,0,1-3.109-17.338,33.97,33.97,0,0,1,3.5-17.1Z",
    transform: "translate(-15466.567 22295.652)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionControl);
export default __webpack_public_path__ + "static/media/version_control.e0d38a1805451fa0f3a48a1e23b5b74b.svg";
export { ForwardRef as ReactComponent };